import axios from "axios";

import type { CreateUserAccountRequest } from "./types";

export const useAccountsApi = (accountHost: string) => {
  const createUser = (
    request: Omit<CreateUserAccountRequest, "create" | "flow" | "newsletterSubscribe">,
  ) =>
    axios.post(
      `${accountHost}/email/login`,
      {
        ...request,
        create: 1,
        flow: 1,
        newsletterSubscribe: 1,
      },
      {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      },
    );

  return { createUser };
};
